import { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { activateAccount } from '../../services/api';
import './AccountActivation.css';

export default function AccountActivation() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const [credentials, setCredentials] = useState(null);

  const uidb64 = searchParams.get('uidb64');
  const token = searchParams.get('token');
  const email = searchParams.get('email');
  const role = searchParams.get('role');

  useState(() => {
    const activate = async () => {
      if (!uidb64 || !token) {
        setStatus('error');
        setMessage('Invalid activation link. Please check your email for the correct link.');
        return;
      }

      try {
        await activateAccount(uidb64, token);
        setStatus('success');
        setMessage('Your account has been activated successfully!');
        setCredentials({ email, role });
      } catch (err) {
        setStatus('error');
        const errorDetails = err.response?.data?.details || err.response?.data?.message;
        setMessage(errorDetails || 'Activation link is invalid or has expired.');
      }
    };

    activate();
  }, [uidb64, token, email, role]);

  const handleLogin = () => {
    if (credentials?.email && credentials?.role) {
      navigate('/login', {
        state: {
          fromActivation: true,
          email: credentials.email,
          role: credentials.role,
        },
      });
    } else {
      navigate('/login');
    }
  };

  return (
    <div className="activation-page-bg">
      <div className="activation-card">
        <div className="activation-icon">
          {status === 'loading' && <div className="spinner" />}
          {status === 'success' && <span className="check-icon">&#10003;</span>}
          {status === 'error' && <span className="error-icon">&#10007;</span>}
        </div>

        <h2 className="activation-title">
          {status === 'loading' && 'Activating your account...'}
          {status === 'success' && 'Account Activated!'}
          {status === 'error' && 'Activation Failed'}
        </h2>

        <p className="activation-message">{message}</p>

        {status === 'success' && (
          <button className="btn-primary" onClick={handleLogin}>
            Login to Your Account
          </button>
        )}

        {status === 'error' && (
          <div className="activation-links">
            <Link to="/register" className="link">Register Again</Link>
            <Link to="/login" className="link">Go to Login</Link>
          </div>
        )}
      </div>
    </div>
  );
}
